import React from 'react';
import { useForm } from "react-hook-form";
import { useRef, useState } from "react";
import VisibilityIcon from '@material-ui/icons/Visibility';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import VpnKeyIcon from '@material-ui/icons/VpnKey';
import { Select } from 'antd';

export const AssignAdminFrom = () => {
    //get current date and time


    let date = new Date();
    let dd = String(date.getDate()).padStart(2, '0');
    let mm = date.getMonth()
    let month = (mm === 1) ? "January " : (mm === 2) ? "February " : (mm === 3) ? " March" : (mm === 4) ? "April" : (mm === 5) ? "May " : (mm === 6) ? "June " : (mm === 7) ? "July " : (mm === 8) ? "August " : (mm === 9) ? "September  " : (mm === 10) ? " Octorber" : (mm === 11) ? "November " : " December"
    let h = date.getHours(), m = date.getMinutes();
    let time = (h > 12) ? (h - 12 + ':' + m + ' PM') : (h + ':' + m + ' AM');
    let yyyy = date.getFullYear();
    let mainTime = time + " " + dd + " " + month + "," + yyyy


    const { register, handleSubmit, watch, formState: { errors } } = useForm();
    const password = useRef({});
    password.current = watch("password", "");
    const onSubmit = (data) => {
        let addData = {
            roleName: "Admin",
            users: data.users,
            password: data.password,
            confirmPassword: data.confirmPassword,
            creationDate: mainTime
        }
        console.log(addData);
    }

    let [showPass, setShowPass] = useState(false)
    let handleShowPass = () => {
        setShowPass(!showPass)
    }

    //  this is for antDesign  func. for select users
    const options = [];
    for (let i = 10; i < 20; i++) {
        const value = `${i.toString(36)}${i}`;
        options.push({
            value
        });
    }
    function handleSelectChange(value) {
        console.log(value);
    }

    return (
        <>
            <form onSubmit={handleSubmit(onSubmit)}>

                <div className="row">
                    <div className="co-lg-6 col-md-6">
                        <h6>Role Name</h6>
                        <input className=" form-control" defaultValue="Admin" disabled   {...register("roleName")} />
                        <small className="mb-2 text-muted">Role is admin by default</small> <br />

                    </div>
                    <div className="co-lg-6 col-md-6">
                        <h6>User</h6>
                        <Select
                            size={"large"}
                            className="rounded"
                            mode="multiple"
                            style={{ width: '100%' }}
                            placeholder="Please select"
                            onChange={handleSelectChange}
                            options={options}
                        />
                        <small className="mb-2 text-muted">Select one or more user to assign as admin</small>
                    </div>
                    <div className="col-lg-6 col-md-12 mt-3">
                        <h6 >Password</h6>
                        <div className="input-icons">
                            <span onClick={handleShowPass}> {showPass ? <VisibilityIcon className="seePass" /> : < VisibilityOffIcon className="seePass" />} </span>
                            <input className="form-control form-control" id="password" type={showPass ? "text" : "password"}  {...register("password", {
                                required: "You must specify a password",
                                minLength: {
                                    value: 8,
                                    message: "Password must have at least 8 characters"
                                }
                            })} />

                            <small className="mb-2 text-muted">Password must contain #@5643!</small><br />
                            {errors.password && <p className="text-danger">{errors.password.message}</p>}

                        </div>
                    </div>
                    <div className="col-lg-6 col-md-12 mt-3">
                        <h6 > Confirm Password</h6>

                        <span onClick={handleShowPass}>  </span>
                        <input className=" form-control" type={showPass ? "text" : "password"}   {...register("confirmPassword", {
                            validate: value => value === password.current || "The passwords do not match"
                        })} />

                        <small className="mb-2 text-muted">Confirm  your Password </small> <br />
                        {errors.confirmPassword && <p className="text-danger">{errors.confirmPassword.message}</p>}

                    </div>

                </div>
                <div className="AntModalSubmitBtn">
                    <input className="btn btn-success" value="Submit" type="submit" />
                </div>
            </form>

        </>

    );
};


export const AssignAdminDetails = ({ userDetails }) => {

    return (
        <>

            <div className="row">
                <h5>Information</h5>
                <div className="co-lg-6 col-md-6">
                    <h6>Name</h6>
                    <input className="form-control " disabled defaultValue={userDetails?.name} /> <br />
                    <small className="mb-2 text-muted">disabled Field</small><br />

                    <h6 >Login ID</h6>
                    <input className="form-control " disabled defaultValue={userDetails?.loginID} /> <br />
                    <small className="mb-2 text-muted">disabled Field</small><br />

                    <h6 >Email</h6>
                    <input className="form-control " disabled defaultValue={userDetails?.email} /> <br />
                    <small className="mb-2 text-muted">disabled Field</small> <br />


                    <h6 >Last Used IP</h6>
                    <input className="form-control " disabled defaultValue="43.988.5.45" /> <br />
                    <small className="mb-2 text-muted">disabled Field</small>


                </div>
                <div className="co-lg-6 col-md-6">
                    <h6 >Mobile</h6>
                    <input className="form-control " disabled defaultValue={userDetails?.mobile} /> <br />
                    <small className="mb-2 text-muted">disabled Field</small> <br />

                    <h6 >Group</h6>
                    <input className="form-control " disabled defaultValue={userDetails?.group} /> <br />
                    <small className="mb-2 text-muted">disabled Field</small><br />


                    <h6 >Role</h6>
                    <input className="form-control " disabled defaultValue={userDetails?.role} /> <br />
                    <small className="mb-2 text-muted">disabled Field</small><br />

                    <h6 >Creation Date</h6>
                    <input className="form-control " disabled defaultValue={userDetails?.creationDate} /> <br />
                    <small className="mb-2 text-muted">disabled Field</small> <br />


                </div>
                <h5>Actions</h5>
                <div className=" ">
                    <button className="resetPass  modalBtn "> <VpnKeyIcon className="ban" />  Reset Password</button>

                </div>

            </div>


        </>
    );
};
